<template>
    <app-layout>
        <template #header>
            <div class="relative flex justify-between items-center">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    <i class="fas fa-file-invoice-dollar mr-2" />
                    Venda de cripto
                </h2>
                <action-buttons />
            </div>
        </template>
        <div class="py-12">
            <div class="max-w-7xl mx-auto px-6 lg:px-8">
                <flash :timeout="5000"/>
                <balance-crypto class="mb-5"/>
                <section class="flex flex-wrap justify-between">
                    <price-crypto
                        :is-buying="false"
                        :price-box-title="'Venda de cripto'"
                        :is-change-perspective="isChangePerspective"
                        :send-order="sendOrder"
                        :processing-order="form.processing"
                        @change-perspective="isChangePerspective = !isChangePerspective"
                        @att-form="attForm"
                    />
                </section>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '../../../Layouts/AppLayout.vue';
import Flash from '../../../Helpers/Flash.vue';
import PriceCrypto from '../components/PriceCrypto.vue';
import Balance from '../../../Helpers/Balance.vue';
import ActionButtons from "../ActionButtons";
import BalanceCrypto from '../Balance.vue';

export default {
    data() {
        return {
            isChangePerspective: true,
            form: this.$inertia.form({
                quote: {
                    id: null,
                    coin: null,
                    settlement: null,
                    value: null,
                    date: null,
                    total: null,
                    amount: null,
                    request_date: null
                }
            }, {
                resetOnSuccess: false,
            }),
        }
    },
    methods: {
        sendOrder() {
            if(this.form.quote.value === 0){
                this.$toast.open({
                    message: 'O valor deve ser maior que zero',
                    type: 'error',
                    duration: 5000,
                    position: 'top-right'
                });
                return
            }
            this.form.post(this.route('trade.store'), {
                preserveScroll: true,
                onSuccess: () => {
                    this.form.processing = false;
                },
                onError: (e) => {
                    this.$toast.open({
                        message: e[0][0] ?? 'Erro ao solicitar ordem, por favor tente novamente mais tarde',
                        type: 'error',
                        duration: 5000,
                        position: 'top-right'
                    });
                    this.form.processing = false;
                }
            });
        },
        attForm(data) {
            this.form.quote = data;
        }
    },
    components: {
        ActionButtons,
        AppLayout,
        Flash,
        PriceCrypto,
        Balance,
        BalanceCrypto
    },
}

</script>
